export const set = (state, action) => {
  return { ...state, theme: action.payload }
}
